/* eslint-disable no-unused-expressions */
import React, { Component, Fragment } from 'react';
import { Spin, Divider, Radio, Tooltip, Checkbox } from 'antd';
import ResultLayout from '@/services/Result/Public/resultLayout';
import NP from 'number-precision';
import getIndex from '@/services/helper/insertionSearch';
import { numConversion } from '@/services/helper/dataProcess';
import WaveformSetting from '@/services/Result/Public/waveform/waveformSetting';
import PostProcessEdgesContent from './PostProcessEdgesContent'
import MeasurementContent from './measurement/measurementContent'
import VictimSummary from './victimSummary'
import photo from '@/components/PublicSvg/photo.svg';
import saveSvg from 'save-svg-as-png';
import { SweepResultData } from '../../../../services/Sierra';
import ResultTreeList from '../../../../components/ResultTreeList';
import { WAVEFORM_EXP_CHECK, RESULT, VICTIM } from '../../../../components/ResultTreeList/nodeRender';
import { experimentListTitleRender, sweepExpCheckTitle, waveformPinTitle, getSignalTitle, getSweepPinTitle, RESULT_TREE_SIGNAL, RESULT_TREE_SWEEP_PIN, WAVEFORM_PIN } from './resultTreeRender';
/* import ResultZoom from '../../../../components/ResultTopMenu/resultZoom'; */
import '../index.css';
import './new.css';
import { filterVictimDataListBySelected } from '../../../../services/Sierra/results/dataHandle';

NP.enableBoundaryChecking(false);
class WaveForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postProcessPanelVisible: false,
      sweepPostProcessConfig: {},
      curveMouseObj: {},
      selectedVictimSignals: []
    }
  }

  componentDidMount = () => {
    if (this.props.compRef) {
      this.props.compRef(this);
    }
    window.addEventListener('resize', this.resize);
  }

  componentDidUpdate = (prevProps) => {
    const { verificationSubId, verificationId, recalc, sweepReCalc, expVerificationId, sweep } = this.props;

    if ((!sweep && verificationId !== prevProps.verificationId && verificationSubId)
      || (sweep && expVerificationId !== prevProps.expVerificationId && expVerificationId)) {
      // Close postProcess when switching between different verifications
      this.setState({
        postProcessPanelVisible: false,
        sweepPostProcessConfig: {},
        currentPostProcessData: {}
      })
    }

    if ((recalc && recalc !== prevProps.recalc)
      || ((!prevProps.sweepReCalc || !prevProps.sweepReCalc.length) && (sweepReCalc && sweepReCalc.length))) {
      this.setState({
        postProcessPanelVisible: false,
        sweepPostProcessConfig: {},
        currentPostProcessData: {}
      }, () => {
        this.changeWidthCB()
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  getPPROCConfig = (processId) => {
    let sweepPostProcessConfig = {};
    const { compInfo, sweep, isNewPPROCObj } = this.props;
    let isSweepNewPPROC = false, sweepClock = "";
    if (sweep && processId) {
      const _currentCompInfo = compInfo.find(item => item.portSelectId === processId)
      if (_currentCompInfo) {
        sweepPostProcessConfig = { ..._currentCompInfo.postProcessConfig };
        const curveNames = (_currentCompInfo.curveName || "").split("_");
        const id = curveNames[curveNames.length - 1];
        isSweepNewPPROC = isNewPPROCObj[id];
        let config = SweepResultData.getConfig(id);
        sweepClock = config ? config.clock || "" : "";
      }
    }
    return { sweepPostProcessConfig, isSweepNewPPROC, sweepClock }
  }

  setDefaultProcessData = (signalNames) => {
    const { resultOpera = {} } = this.props;
    const { processId, processSignal } = resultOpera || {};
    const processData = this.getProcessDataById(processId, processSignal, signalNames);
    const { sweepPostProcessConfig, isSweepNewPPROC, sweepClock } = this.getPPROCConfig(processId)
    this.setState({
      currentPostProcessData: processData,
      postProcessPanelVisible: Object.keys(processData).length ? true : false,
      sweepPostProcessConfig,
      isSweepNewPPROC,
      sweepClock
    }, () => {
      this.changeWidthCB()
    })
  }

  getProcessDataById = (processId, signal, signalNames) => {
    let _postProcessData = {};
    if (!processId) {
      return _postProcessData
    }
    const { sweep } = this.props;
    if (sweep) {
      const { compInfo } = this.props;
      const _currentCompInfo = compInfo.find(item => item.portSelectId === processId)
      if (_currentCompInfo) {
        _postProcessData = { ..._currentCompInfo.postProcessData, signal }
      }
    } else {
      if (signalNames && !signalNames.includes(signal)) {
        return _postProcessData
      }
      const { dataList = {} } = this.props;
      const { Waveform = {} } = dataList
      const { list = [] } = Waveform;
      const data = list.map(l => l.children || []).flat(2);
      const d = data.find(item => item.id === processId);
      _postProcessData = d && d.postProcessData ? { ...d.postProcessData } : {}
    }
    return _postProcessData
  }

  onComponentChange = (values) => {
    this.props.updateState('selectedComponentKeys', values);
    const curves = this.props.waveform.getCurves();
    curves.forEach((curve, i) => {
      curve.visible = values.includes(i);
    });
    this.reloadAxisCB()
  }

  colorChange = (e, curveIndex) => {
    const value = e.toHexString()
    if (value) {
      const { compInfo, waveform } = this.props;
      const curves = waveform.getCurves();
      compInfo[curveIndex].color = value;
      curves[curveIndex].color = value;
      this.props.updateState('compInfo', compInfo);
      this.reloadAxisCB()
    }
  }

  reloadAxisCB = () => {
    this.props.waveform.updataRawCurvePlot();
  }

  axisChangeCB = (type, { _xMin, _xMax, _yMin, _yMax }) => {
    const plot = this.props.waveform.plot;
    if (type === 'xMin' || type === 'xMax') {
      const xMax = plot.options.xMax,
        xMin = plot.options.xMin,
        start = NP.times(_xMin, 1e-9),
        end = NP.times(_xMax, 1e-9);
      plot.xScale
        .domain([Math.min(start, end), Math.max(start, end)])
        .range([0, plot.size.width]);

      const xrange = plot.xScale.domain(),
        width = plot.size.width,
        startX = NP.times(NP.divide(NP.minus(xrange[0], xMin), NP.minus(xMax, xMin)), width),
        endX = NP.times(NP.divide(NP.minus(xrange[1], xMin), NP.minus(xMax, xMin)), width);
      plot.updateRange(startX, endX);
    } else {
      // y axis
      const yStart = numConversion(parseFloat(_yMin)),
        yEnd = numConversion(parseFloat(_yMax));
      plot.yScale
        .domain([Math.max(yStart, yEnd), Math.min(yStart, yEnd)])
        .nice()
        .range([0, plot.size.height])
        .nice();
    }
    this.reloadAxisCB()
  }

  changeMouse = (time, yPrefix) => {
    /*  this.lastArgs = [time, yPrefix];
 
     if (this.rafId) {
       // There is already a rAF in the queue, so just discard this call.
       return;
     }
 
     this.rafId = requestAnimationFrame(() => {
       this.rafId = null;
       const [time, yPrefix] = this.lastArgs; */
    const { compInfo, waveform, sweep } = this.props;
    const curves = waveform.getCurves();

    if (compInfo.length !== curves.length) return;

    let curveMouseIndex = -1, curveMouseObj = {};

    for (let k = 0; k < curves.length; k++) {
      if (!compInfo[k] || !curves[k].visible) {
        continue;
      }
      curveMouseIndex = this._getIndex(curves[k].x, time);
      if (curveMouseIndex < 0) {
        return
      }
      let y, x1, x2, y1, y2;
      if (curves[k].x[curveMouseIndex] < time && curveMouseIndex + 1 <= curves[k].x.length - 1) {
        x1 = curves[k].x[curveMouseIndex]; y1 = curves[k].y[curveMouseIndex];
        x2 = curves[k].x[curveMouseIndex + 1]; y2 = curves[k].y[curveMouseIndex + 1];
        //Linear interpolation
        y = y1 + ((y2 - y1) / (x2 - x1)) * (time - x1);
      } else if (curves[k].x[curveMouseIndex] > time && curveMouseIndex - 1 >= 0) {
        x1 = curves[k].x[curveMouseIndex - 1]; y1 = curves[k].y[curveMouseIndex - 1];
        x2 = curves[k].x[curveMouseIndex]; y2 = curves[k].y[curveMouseIndex];
        y = y1 + ((y2 - y1) / (x2 - x1)) * (time - x1);
      } else {
        y = curves[k].y[curveMouseIndex];
      }

      if (sweep) {
        const findComp = compInfo.find(item => item.curveName === curves[k].name);
        if (!findComp) {
          continue;
        }
        const current = curveMouseIndex > -1 ? yPrefix(y) + 'V' : '';
        curveMouseObj[findComp.portSelectId] = current;
      } else {
        const current = curveMouseIndex > -1 ? yPrefix(y) + 'V' : '';
        curveMouseObj[curves[k].name] = current
      }
    }

    this.setState({
      curveMouseObj
    })
    /* }) */
  }

  getListChildIndex(curve, list) {
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].children.length; j++) {
        if (list[i].children[j].id === curve.name) {
          return {
            listIndex: i,
            childIndex: j
          }
        }
      }
    }
    return {
      listIndex: -1,
      childIndex: -1
    }
  }

  getSweepListChildIndex(curveIndex, list) {
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].children.length; j++) {
        const curveIndexObj = list[i].children[j].curveIndex;
        const groupName = Object.keys(curveIndexObj).find(item => curveIndexObj[item] === curveIndex);
        if (!!groupName) {
          return {
            listIndex: i,
            childIndex: j,
            groupName
          }
        }
      }
    }
    return {
      listIndex: -1,
      childIndex: -1,
      groupName: null
    }
  }

  cancelMove = () => {
    this.setState({
      curveMouseObj: {}
    })
  }

  changeAxis = (axis) => {
    this.props.waveformSetting && this.props.waveformSetting.setAxis(axis);
  }

  _getIndex(xPoints, time) {
    return getIndex(xPoints, time, 0, xPoints.length - 1);
  }

  clickPostProcessData = (data) => {
    const { portSelect, compInfo, sweep } = this.props;

    if (!data.display) {
      this.props.waveform.plot.removeCrossProbing([]);
      return;
    }

    let values = [], clkValues = [], groups = [];

    if (portSelect[data.signal] && portSelect[data.signal].length) {
      if (!portSelect[data.signal].includes(data.curveName)) {
        values = [...new Set([...portSelect[data.signal], data.curveName])]
      }
    } else {
      values = [data.curveName]
    }

    const clkPortSelected = sweep ? data.sweepPortSelectId : data.clkCurveName;
    if (data.clkSignal && portSelect[data.clkSignal] && portSelect[data.clkSignal].length) {

      if (!portSelect[data.clkSignal].includes(clkPortSelected)) {
        clkValues = [...new Set([...portSelect[data.clkSignal], clkPortSelected])]
      }
    } else {
      clkValues = data.clkSignal ? [clkPortSelected] : []
    }

    if (values.length || clkValues.length) {
      values.length && groups.push({ rowName: data.signal, values });
      clkValues.length && data.clkSignal && groups.push({ rowName: data.clkSignal, values: clkValues });
      this.props.changePorts(groups)
    }
    const currentInfo = compInfo.find(item => item.portSelectId === data.curveName)
    if (currentInfo) {
      this.props.waveform.plot.crossProbingPlot({ ...data, selectedKeys: [currentInfo.curveIndex], usage: currentInfo.usage })
    }
  }

  setTargetLinesValue = ({ horizontalLine, drawType, horizontalLineSetting }) => {
    if (!this.props.waveform.plot || !this.props.waveform.plot.targetLine) return;
    // save data
    this.props.waveform.plot.targetLine.setValue({ horizontalLine, horizontalLineSetting })
    this.props.waveform.plot.targetLine.drawLines(this.props.waveform.plot.root, drawType);
  }

  printResult = (e) => {
    e.preventDefault();
    const options = {
      backgroundColor: '#ffffff',
      encoderOptions: 1
    }
    document.querySelector(".plot") && saveSvg.saveSvgAsPng(document.querySelector(".plot"), "Waveform_result.png", options);
  }

  updateGPIOSpec = (sweepName, postProcessConfig) => {
    const { sweep } = this.props;
    if (sweep) {
      this.setState({
        sweepPostProcessConfig: JSON.parse(JSON.stringify(postProcessConfig || this.state.sweepPostProcessConfig || {}))
      })
      this.props.updateGPIOSpecInPPROCConfig(postProcessConfig, sweepName);

    } else {
      this.props.updateGPIOSpecInPPROCConfig(postProcessConfig);
    }

  }

  resultLeft = () => {
    const { loading, recalc, postProcessConfig, verificationId, sweep, resultOpera, libraryTreeInfo, interfaceTag, compInfo, isNewPPROC, clock } = this.props;
    const { currentPostProcessData, postProcessPanelVisible, sweepPostProcessConfig = {}, isSweepNewPPROC, sweepClock } = this.state;
    const waveformHeight = postProcessPanelVisible && !recalc ? '58%' : '100%';
    return (
      <Spin spinning={loading} size='large'>
        <div
          className='waveform-svg'
          style={{ width: "100%", height: waveformHeight }}>
          <svg ref={this.props.svgRef}></svg>
          {/*  {ResultZoom({
            zoomIn: waveform && waveform.plot ? waveform.plot.zoomIn : null,
            zoomOut: waveform && waveform.plot ? waveform.plot.zoomOut : null,
            fitView: waveform && waveform.plot ? waveform.plot.fitView : null,
            plot: waveform ? waveform.plot : null
          })} */}
          <div className='sierra-result-curve-right'>
            <div className='photo-box' onClick={this.printResult}>
              <img src={photo} alt="" className='sierra-photo' />
            </div>
          </div>
        </div>
        {!recalc && <div className='waveform-post-process-container'>
          {/* {postProcessPanelVisible && <PostProcessPanelContent closeModal={this.changePostProcessVisible} currentPostProcessData={currentPostProcessData} clickPostProcessData={this.clickPostProcessData} />} */}
          {postProcessPanelVisible &&
            <PostProcessEdgesContent
              sweep={sweep}
              compInfo={compInfo}
              resultOpera={resultOpera}
              closeModal={this.changePostProcessVisible}
              currentPostProcessData={currentPostProcessData}
              clickPostProcessData={this.clickPostProcessData}
              setResultOpera={this.props.setResultOpera}
              onClearSelected={node => this.clearSelected = node}
              recalc={recalc}
              verificationId={verificationId}
              interfaceTag={interfaceTag}
              postProcessConfig={sweep ? sweepPostProcessConfig : postProcessConfig}
              setTargetLinesValue={this.setTargetLinesValue}
              libraryTreeInfo={libraryTreeInfo}
              _updateLibraryTree={this.props._updateLibraryTree}
              updateGPIOSpec={this.updateGPIOSpec}
              isNewPPROC={isNewPPROC}
              isSweepNewPPROC={isSweepNewPPROC}
              clock={sweep ? sweepClock : clock}
            />}
        </div>}
      </Spin>
    )
  }

  PCBLegend = () => {
    const { allDesigns } = this.props;
    return <div>
      {allDesigns.map(item => {
        return <div key={item.name} className="sweep-waveform-pcb-legend">
          <div className="sweep-waveform-pcb-legend-content" style={{ position: 'absolute' }}>
            <span className="sweep-waveform-pcb-legend-color" style={{ background: item.color }}></span>
            <Tooltip title={item.name} classNames={{ root: "aurora-tooltip" }}>
              <span className="sweep-waveform-pcb-legend-title">{item.name}</span>
            </Tooltip>
          </div>
        </div>
      })}
    </div>
  }

  ResultRowSelectCheckbox = (verticallyData) => {
    const { showChecked, experimentListData } = verticallyData;
    const { isPostProcess, sweepTimeShowList } = this.props;
    if (showChecked) {
      return <div className="sparameter-result-checkbox-content">
        <div style={{ display: 'inline-flex', width: '100%' }}>
          <div className="rocky-sparameter-result-checkout-blank"></div>
          {experimentListData.map((item, index) =>
            <Fragment key={item.name}>
              <span
                className='sparameter-result-menu-title sparameter-sweep-checkbox sparameter-all-sweep-checkbox'
                style={index === 0 ? { marginLeft: 240 } : {}}>
                <Checkbox
                  indeterminate={item.indeterminate}
                  onChange={(e) => this.props.changeSelectRowAll(item)}
                  checked={item.allChecked}
                ></Checkbox>
              </span>
              {isPostProcess && (sweepTimeShowList || []).includes(item.name) && <div className='sparameter-sweep-post-title-box'></div>}
            </Fragment>
          )}
        </div>
      </div>
    }
  }

  changePostProcessVisible = (e, type, postProcessData, rowName, currentId) => {
    // There is only one net selected when clicking
    e.stopPropagation();
    e.preventDefault()

    const { postProcessPanelVisible, currentPostProcessData } = this.state;
    const { portSelect, isNewPPROCObj } = this.props;
    let _postProcessPanelVisible = true, _postProcessData = {}, sweepPostProcessConfig = {}, isSweepNewPPROC = false, sweepClock = "";
    if (type === 'sweep') {
      const { compInfo } = this.props;
      const _currentCompInfo = compInfo.find(item => item.portSelectId === currentId)
      if (_currentCompInfo) {
        _postProcessData = { ..._currentCompInfo.postProcessData, signal: rowName }
        sweepPostProcessConfig = { ..._currentCompInfo.postProcessConfig }
        const curveNames = (_currentCompInfo.curveName || "").split("_");
        const id = curveNames[curveNames.length - 1];
        isSweepNewPPROC = isNewPPROCObj[id];
        let config = SweepResultData.getConfig(id);
        sweepClock = config ? config.clock || "" : "";
      }
    } else {
      _postProcessData = { ...postProcessData }
    }

    if (postProcessPanelVisible && currentPostProcessData) {
      if (_postProcessData.title === currentPostProcessData.title) {
        _postProcessData = {}
        _postProcessPanelVisible = false;
      }
    }

    this.setState({
      postProcessPanelVisible: _postProcessPanelVisible,
      currentPostProcessData: _postProcessData,
      sweepPostProcessConfig: sweepPostProcessConfig,
      isSweepNewPPROC,
      sweepClock
    }, () => {
      if (this.props.setResultOpera) {
        const obj = _postProcessPanelVisible ? { processId: currentId, processSignal: rowName } : { processId: "", processSignal: "" }
        this.props.setResultOpera(obj)
      }
      this.changeWidthCB()
      let _portSelect = { ...portSelect };

      if (_postProcessPanelVisible && (!_portSelect[rowName] || !_portSelect[rowName].includes(currentId))) {
        const values = _portSelect[rowName] ? [..._portSelect[rowName], currentId] : [currentId];
        this.props.changePort(values, rowName)
      }

      if (!_postProcessPanelVisible) {
        this.setTargetLinesValue({ horizontalLine: [], drawType: "horizontalLine", horizontalLineSetting: [] })
      }
    })
  }

  changeDisplayMode = (e) => {
    this.clearSelected && this.clearSelected();
    this.props.displayModeChange(e)
  }

  resize = () => {
    this.props.waveform && this.props.waveform.plot && this.props.waveform.plot.redrawPlot(this.props.svgRef.current);
    this.clearSelected && this.clearSelected();
  }

  ResultPostProcess = (postProcessData) => {
    if (postProcessData && Object.keys(postProcessData).length) {
      const { edgesInfo, timeUnit } = postProcessData;
      if (!edgesInfo || (!edgesInfo.minInfo && !edgesInfo.maxInfo)) { return <div className="post-processing-tree-box"></div> }
      return (<div className="post-processing-tree-box">
        <div className='post-processing-tree-content'>
          {[edgesInfo.maxInfo.timeRising, edgesInfo.minInfo.timeRising, edgesInfo.maxInfo.timeFalling, edgesInfo.minInfo.timeFalling].map((item, index) => {
            const value = !isNaN(item) ? Number(item).toFixed(2) : item;
            return <Tooltip
              key={index}
              className="post-processing-tree-data-span"
              title={`${value}${timeUnit}`}
              classNames={{ root: 'aurora-tooltip' }}
              placement='topLeft'
            >{`${value}${timeUnit}`}</Tooltip>
          })}
        </div>
      </div>)
    } else {
      return <div className="post-processing-tree-box"></div>
    }
  }

  postProcessTitle = (fileName, type) => {
    if (fileName === 'resultList') {
      return ['Rising', 'Falling'].map((item, index) =>
        <span
          className='post-processing-result-menu-title'
          key={item}
        >
          <Tooltip title={item} classNames={{ root: 'aurora-tooltip' }}>{item}</Tooltip>
        </span>
      )
    }
    return ['Max', 'Min', 'Max', 'Min'].map((item, index) => {
      return <span
        className='post-processing-result-title'
        key={index}
      >
        <Tooltip title={item} classNames={{ root: 'aurora-tooltip' }}>{item}</Tooltip>
      </span>
    })
  }

  resultTreeTitleRender = (nodeData, actions) => {
    let children = null;
    switch (nodeData.type) {
      case WAVEFORM_PIN:
        children = waveformPinTitle(nodeData, actions);
        break;
      case RESULT_TREE_SWEEP_PIN:
        children = getSweepPinTitle(nodeData, actions);
        break;
      case RESULT_TREE_SIGNAL:
        children = getSignalTitle(nodeData, actions);
        break;
      case WAVEFORM_EXP_CHECK:
        children = sweepExpCheckTitle(nodeData, actions);
        break;
      default:
        break;
    }
    return children;
  }

  resultTitleRender = (nodeData, actions, hasVictim) => {
    const { isPostProcess, postProcessTitle, experimentList } = actions;
    if (experimentList && experimentList.length) {
      return experimentListTitleRender(actions)
    }

    if (isPostProcess && postProcessTitle && !hasVictim) {
      return this.postProcessTitle("resultList")
    }
  }

  initSelectedVictimSignals = (signals) => {
    this.setState({ selectedVictimSignals: signals })
  }

  changeSelectedVictimSignals = (selectedRowKeys) => {
    const { selectedVictimSignals } = this.state;
    const addSignals = selectedRowKeys.filter(item => !selectedVictimSignals.includes(item));
    const removeSignals = selectedVictimSignals.filter(item => !selectedRowKeys.includes(item));
    const { victimDataList, expandedKeys } = this.props;
    const { list } = victimDataList.Waveform;
    this.setState({ selectedVictimSignals: selectedRowKeys });
    let groups = []
    if (addSignals.length) {
      groups = addSignals.map(item => {
        const row = list.find(l => l.id === item) || {};
        const values = (row.children || []).map(c => c.id);
        return { rowName: item, values }
      });
    }

    if (removeSignals.length) {
      groups = removeSignals.map(item => ({ rowName: item, values: null }));
    }

    if (!expandedKeys.includes("Victim")) {
      this.props.updateExpandKeys([...expandedKeys, "Victim"]);
    }
    this.props.changePorts(groups)
  }

  resultRight = () => {
    const { displayMode, waveform, allDesigns,
      resultList, portSelect, dataList, sweep, allPortSelect,
      changeSelectAll, isPostProcess,
      compInfo, verificationSubId, verificationId, currentProjectId,
      postProcessConfig, recalc, progress, currentInterfaceInfo,
      measurePanelVisible, singleProgress, sweepReCalc, sweepTimeShowList, expandedKeys,
      victimSummaryVisible, hasVictim, victimDataList
    } = this.props;
    const { currentPostProcessData, curveMouseObj, selectedVictimSignals } = this.state;
    return (
      <div className={!sweep ? "sierra-waveform-result-list sierra-waveform-result-post-process-list" : "sierra-waveform-result-list sierra-waveform-result-sweep-list"}>
        <div className='sierra-waveform-result-list-container'>
          {sweep ? this.PCBLegend() : null}
          <ResultTreeList
            className="sierra-waveform-tree"
            type={RESULT}
            resultList={dataList}
            experimentList={resultList}
            displayMode={'Waveform'}
            colorChange={this.props.colorChange}
            designs={allDesigns}
            isParallel={sweep}
            checkStrictly={sweep}
            allPortSelect={allPortSelect}
            portSelect={hasVictim ? portSelect : portSelect}
            changePort={this.props.changePort}
            changeSinglePort={this.props.changeSinglePort}
            postProcessTitle={this.postProcessTitle}
            changePostProcessVisible={this.changePostProcessVisible}
            isPostProcess={isPostProcess}
            recalc={recalc}
            sweepReCalc={sweepReCalc}
            curveMouseObj={curveMouseObj}
            expandedKeys={expandedKeys}
            currentPostProcessData={currentPostProcessData}
            sweepTimeShowList={sweepTimeShowList}
            showSweepTime={this.props.showSweepTime}
            updateExpandKeys={this.props.updateExpandKeys}
            ResultPostProcess={this.ResultPostProcess}
            changeSelectAll={changeSelectAll}
            getSweepChecked={this.props.getSweepChecked}
            changeTreeCheckedKeys={this.props.changeTreeCheckedKeys}
            getTreeCheckedKeys={this.props.getTreeCheckedKeys}
            resultTreeRender={this.resultTreeTitleRender}
            resultTitleRender={this.resultTitleRender}
          />

          {hasVictim && !sweep ? <ResultTreeList
            className="sierra-waveform-tree"
            type={VICTIM}
            resultList={filterVictimDataListBySelected(victimDataList, selectedVictimSignals)}
            experimentList={resultList}
            displayMode={'Waveform'}
            colorChange={this.props.colorChange}
            designs={allDesigns}
            isParallel={sweep}
            checkStrictly={sweep}
            allPortSelect={allPortSelect}
            portSelect={portSelect}
            changePort={this.props.changePort}
            changeSinglePort={this.props.changeSinglePort}
            isPostProcess={false}
            curveMouseObj={curveMouseObj}
            expandedKeys={expandedKeys}
            currentPostProcessData={currentPostProcessData}
            sweepTimeShowList={sweepTimeShowList}
            showSweepTime={this.props.showSweepTime}
            updateExpandKeys={this.props.updateExpandKeys}
            ResultPostProcess={this.ResultPostProcess}
            changeSelectAll={changeSelectAll}
            getSweepChecked={this.props.getSweepChecked}
            changeTreeCheckedKeys={this.props.changeTreeCheckedKeys}
            getTreeCheckedKeys={this.props.getTreeCheckedKeys}
            resultTreeRender={this.resultTreeTitleRender}
            resultTitleRender={(nodeData, actions) => this.resultTitleRender(nodeData, actions, hasVictim)}
          /> : null}
        </div>
        <div className='waveform-post-process-box'>
          {/*  <Divider orientation="left" className='waveform-setting-title'>
            Measurement Conditions
            {recalc ? null
              : <Icon type="edit" className="aurora-icon-hover-color sierra-measure-edit-icon" onClick={(e) => this.changeMeasureVisible(true)} />}
          </Divider>
          {recalc && progress !== false && <Progress percent={progress >= 0 ? progress : 100} className="sierra-measure-progress" />} */}
          {/* <Spin spinning={recalc}> */}
          {measurePanelVisible ? <MeasurementContent
            compInfo={compInfo}
            experimentList={resultList}
            currentInterfaceInfo={currentInterfaceInfo}
            verificationSubId={verificationSubId}
            verificationId={verificationId}
            currentProjectId={currentProjectId}
            changeMeasureVisible={this.props.changeMeasureVisible}
            postProcessConfig={postProcessConfig}
            recalcMeasure={this.props.recalcMeasure}
            recalc={recalc}
            progress={progress}
            sweep={sweep}
            singleProgress={singleProgress}
            sweepReCalc={sweepReCalc}
            _updateSweepReCalc={this.props._updateSweepReCalc}
            _updateProgress={this.props._updateProgress}
          /> : null}
          {/*   </Spin> */}

          {victimSummaryVisible ? <VictimSummary
            verificationId={verificationId}
            allDesigns={allDesigns}
            changeVictimSummaryVisible={this.props.changeVictimSummaryVisible}
            selectedVictimSignals={selectedVictimSignals}
            changeselectedVictimSignals={this.changeSelectedVictimSignals}
          /> : null}
        </div>
        <div className='waveform-setting-box'>
          <Divider orientation="left" className='waveform-setting-title'>Setting</Divider>
          <div className='waveform-setting-box-setup'>
            <span className='display-mode-title'>Display Mode</span>
            <Radio.Group onChange={this.changeDisplayMode} value={displayMode}>
              <Radio value={'Fast'}>Fast</Radio>
              <Radio value={'Hi-Re'}>Hi-Re</Radio>
            </Radio.Group>
            <WaveformSetting
              onRef={this.props.onRef}
              plot={waveform ? waveform.plot : null}
              axisChangeCB={this.axisChangeCB}
              reloadAxisCB={this.reloadAxisCB}
            />
          </div>
        </div>
      </div>
    );
  }

  changeWidthCB = () => {
    if (this.props.waveform) {
      this.props.waveform.plot.redrawPlot(this.props.svgRef.current);
    }
  }

  render() {
    return (
      <div className='waveform waveform-clear sierra-result-waveform'>
        <ResultLayout
          defaultRightWidth={360}
          resultLeft={this.resultLeft}
          resultRight={this.resultRight}
          changeWidthCB={this.changeWidthCB}
        />
      </div>
    )
  }
}

export default WaveForm;